(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-testimonials"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const track = document.getElementById('testimonialsTrack');
  const prevBtn = document.getElementById('prevBtn');
  const nextBtn = document.getElementById('nextBtn');
  const progressFill = document.getElementById('progressFill');

  if (!track) return;

  const gap = 24;
  let currentIndex = 0;
  const cards = track.querySelectorAll('.testimonial-card');
  const total = cards.length;

  function getVisibleCount() {
    const w = window.innerWidth;
    if (w <= 768) return 1;
    if (w <= 1024) return 2;
    return parseInt('{{ section.settings.cards_per_scroll }}') || 3;
  }

  function getMaxIndex() {
    return Math.max(0, total - getVisibleCount());
  }

  function updateCarousel() {
    if (!cards.length) return;
    const cardWidth = cards[0].offsetWidth;
    const visible = getVisibleCount();
    const max = getMaxIndex();

    currentIndex = Math.min(Math.max(currentIndex, 0), max);
    track.style.transform = 'translateX(' + (-currentIndex * (cardWidth + gap)) + 'px)';

    prevBtn.disabled = currentIndex === 0;
    nextBtn.disabled = currentIndex >= max;

    const fillWidth = (visible / total) * 100;
    const fillLeft = total > visible
      ? (currentIndex / (total - visible)) * (100 - fillWidth)
      : 0;
    progressFill.style.width = fillWidth + '%';
    progressFill.style.left = fillLeft + '%';
  }

  prevBtn.addEventListener('click', function () {
    currentIndex = Math.max(0, currentIndex - getVisibleCount());
    updateCarousel();
  });

  nextBtn.addEventListener('click', function () {
    currentIndex = Math.min(getMaxIndex(), currentIndex + getVisibleCount());
    updateCarousel();
  });

  // Touch swipe support
  let touchStartX = 0;
  let touchStartY = 0;
  let isSwiping = false;

  track.addEventListener('touchstart', function (e) {
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
    isSwiping = false;
  }, { passive: true });

  track.addEventListener('touchmove', function (e) {
    const dx = Math.abs(e.touches[0].clientX - touchStartX);
    const dy = Math.abs(e.touches[0].clientY - touchStartY);
    if (dx > dy && dx > 5) isSwiping = true;
  }, { passive: true });

  track.addEventListener('touchend', function (e) {
    if (!isSwiping) return;
    const dx = e.changedTouches[0].clientX - touchStartX;
    if (Math.abs(dx) > 40) {
      if (dx < 0) {
        currentIndex = Math.min(getMaxIndex(), currentIndex + 1);
      } else {
        currentIndex = Math.max(0, currentIndex - 1);
      }
      updateCarousel();
    }
  });

  window.addEventListener('resize', updateCarousel);
  updateCarousel();
});

  } catch(e) { console.error(e); }
})();
})();
